/* eslint-disable react/jsx-no-target-blank */
import PropTypes from 'prop-types';
import cookie from 'js-cookie';
import React, { Component } from 'react';
import { Form, Upload, Button, message, Icon } from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './style.css';

const uploadProps = (action, query) => ({
  name: 'xlsx_file',
  multiple: false,
  action,
  accept:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  headers: {
    Authorization: `jwt ${cookie.get('AUTH')}`,
  },
  onChange(info) {
    const { status } = info.file;
    if (status === 'error') {
      message.error(`问题导入失败，${info.file.response}`, 5);
    } else if (status !== 'uploading') {
      message.success('问题导入成功');
      query();
    }
  },
});

@withStyles(s)
class BatchAdd extends Component {
  state = {
    questionImportTemplateUrl: '',
    uploadAction: '',
  };
  componentDidMount() {
    // eslint-disable-next-line
    this.setState({
      questionImportTemplateUrl: `${window.G.backendApi}${
        window.G.questionImportTemplate
      }`,
      uploadAction: `${window.G.backendApi}/knowledge/answer/xlsx_import/`,
    });
  }
  render() {
    const { questionImportTemplateUrl, uploadAction } = this.state;
    const { query } = this.props;
    return (
      <div className={s.batchAdd}>
        <div className={s.downloadExcel}>
          <a href={questionImportTemplateUrl} target="_blank">
            请先点击下载批量导入模板
          </a>
        </div>
        <Upload {...uploadProps(uploadAction, query)}>
          <Button>
            <Icon type="upload" /> 点击上传 excel 文件
          </Button>
        </Upload>
      </div>
    );
  }
}

BatchAdd.propTypes = {
  query: PropTypes.func.isRequired,
};

export default Form.create()(BatchAdd);
